import React from 'react';

interface MapLoadingProps {
  className?: string;
  height?: string;
}

export const MapLoading: React.FC<MapLoadingProps> = ({ 
  className = '', 
  height = '100vh' 
}) => {
  return (
    <div className={`map-loading ${className}`} style={{ height }}>
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-icon">📍</div>
      </div>
      <p className="loading-text">Chargement de la carte<span className="loading-dots"></span></p>
    </div>
  );
};

interface MapErrorProps {
  error: string;
  className?: string;
  height?: string;
  onReload: () => void;
}

export const MapError: React.FC<MapErrorProps> = ({ 
  error, 
  className = '', 
  height = '100vh',
  onReload 
}) => {
  return (
    <div className={`map-error ${className}`} style={{ height }}>
      <div className="error-message">
        <h3>Erreur de chargement de la carte</h3>
        <p>{error}</p>
        <button onClick={onReload}>Recharger</button>
      </div>
    </div>
  );
};

interface MapEmptyStateProps {
  show: boolean;
}

export const MapEmptyState: React.FC<MapEmptyStateProps> = ({ show }) => {
  if (!show) return null;
  
  return (
    <div style={{ 
      position: 'absolute', 
      top: '10px', 
      left: '10px', 
      zIndex: 1000, 
      background: 'white', 
      padding: '10px', 
      borderRadius: '5px', 
      boxShadow: '0 2px 5px rgba(0,0,0,0.2)' 
    }}>
      <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
        Aucune donnée à afficher
      </p>
    </div>
  );
};
